// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"63a73a53","159":"6244a4fc","311":"babc4319","408":"cdcd7d94","453":"d855a71b","583":"55929474","718":"d38a1f0f","795":"9435f94b"}[chunkId] + ".chunk.js";
};